const ACTIONS_REPORT_SCHEDULE = {
  INVALIDATE: 'REPORT_SCHEDULES_INVALIDATE',
  RECEIVE: 'REPORT_SCHEDULES_RECEIVE',
  DELETE: 'REPORT_SCHEDULE_DELETE',
  UPDATE: 'REPORT_SCHEDULE_UPDATE',
};

export default ACTIONS_REPORT_SCHEDULE;
